import {IxApi, IxFetch, testTokenScope} from './api'
import {catLink, itemLink, msg} from 'vue-src/utils'

import MakeOwl from './make-owl'

const vAffix = {
  bind(el, binding, vnode, oldVnode) {
    let combined_options = {
      offset: {
        top: 0,
        bottom: function () {
          return (this.bottom =
              document.getElementById('footer').scrollHeight)
        },
      }
    }
    window.themejQuery.extend(true, combined_options, binding.value)
    window.themejQuery(el).affix(combined_options)
  }
}


export default {
  install: function (Vue, options) {


    Vue.prototype.IxFetch = IxFetch
    Vue.prototype.$IxApi = IxApi
    Vue.prototype.$hasScope = testTokenScope

    Vue.prototype.noImageProvidedUrl = window.noImageProvidedUrl

    Vue.prototype.$makeOwl = MakeOwl

    Vue.prototype.$catLink = catLink
    Vue.prototype.$itemLink = itemLink
    Vue.prototype.$msg = msg


    Vue.directive('affix', vAffix)
    Vue.directive('owl', MakeOwl)


    Vue.prototype.$snippet = function (name, def = '') {

      return window.ixsnippet(name, def)

    }


  }
}





// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/IxPlugin/index.js